"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StayAlignedSettingsT = exports.StayAlignedSettings = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
class StayAlignedSettings {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsStayAlignedSettings(bb, obj) {
        return (obj || new StayAlignedSettings()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsStayAlignedSettings(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new StayAlignedSettings()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    enabled() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    extraYawCorrection() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    hideYawCorrection() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    standingEnabled() {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    standingUpperLegAngle() {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : 0.0;
    }
    standingLowerLegAngle() {
        const offset = this.bb.__offset(this.bb_pos, 14);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : 0.0;
    }
    standingFootAngle() {
        const offset = this.bb.__offset(this.bb_pos, 16);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : 0.0;
    }
    sittingEnabled() {
        const offset = this.bb.__offset(this.bb_pos, 18);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    sittingUpperLegAngle() {
        const offset = this.bb.__offset(this.bb_pos, 20);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : 0.0;
    }
    sittingLowerLegAngle() {
        const offset = this.bb.__offset(this.bb_pos, 22);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : 0.0;
    }
    sittingFootAngle() {
        const offset = this.bb.__offset(this.bb_pos, 24);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : 0.0;
    }
    flatEnabled() {
        const offset = this.bb.__offset(this.bb_pos, 26);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    flatUpperLegAngle() {
        const offset = this.bb.__offset(this.bb_pos, 28);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : 0.0;
    }
    flatLowerLegAngle() {
        const offset = this.bb.__offset(this.bb_pos, 30);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : 0.0;
    }
    flatFootAngle() {
        const offset = this.bb.__offset(this.bb_pos, 32);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : 0.0;
    }
    setupComplete() {
        const offset = this.bb.__offset(this.bb_pos, 34);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    static startStayAlignedSettings(builder) {
        builder.startObject(16);
    }
    static addEnabled(builder, enabled) {
        builder.addFieldInt8(0, +enabled, +false);
    }
    static addExtraYawCorrection(builder, extraYawCorrection) {
        builder.addFieldInt8(1, +extraYawCorrection, +false);
    }
    static addHideYawCorrection(builder, hideYawCorrection) {
        builder.addFieldInt8(2, +hideYawCorrection, +false);
    }
    static addStandingEnabled(builder, standingEnabled) {
        builder.addFieldInt8(3, +standingEnabled, +false);
    }
    static addStandingUpperLegAngle(builder, standingUpperLegAngle) {
        builder.addFieldFloat32(4, standingUpperLegAngle, 0.0);
    }
    static addStandingLowerLegAngle(builder, standingLowerLegAngle) {
        builder.addFieldFloat32(5, standingLowerLegAngle, 0.0);
    }
    static addStandingFootAngle(builder, standingFootAngle) {
        builder.addFieldFloat32(6, standingFootAngle, 0.0);
    }
    static addSittingEnabled(builder, sittingEnabled) {
        builder.addFieldInt8(7, +sittingEnabled, +false);
    }
    static addSittingUpperLegAngle(builder, sittingUpperLegAngle) {
        builder.addFieldFloat32(8, sittingUpperLegAngle, 0.0);
    }
    static addSittingLowerLegAngle(builder, sittingLowerLegAngle) {
        builder.addFieldFloat32(9, sittingLowerLegAngle, 0.0);
    }
    static addSittingFootAngle(builder, sittingFootAngle) {
        builder.addFieldFloat32(10, sittingFootAngle, 0.0);
    }
    static addFlatEnabled(builder, flatEnabled) {
        builder.addFieldInt8(11, +flatEnabled, +false);
    }
    static addFlatUpperLegAngle(builder, flatUpperLegAngle) {
        builder.addFieldFloat32(12, flatUpperLegAngle, 0.0);
    }
    static addFlatLowerLegAngle(builder, flatLowerLegAngle) {
        builder.addFieldFloat32(13, flatLowerLegAngle, 0.0);
    }
    static addFlatFootAngle(builder, flatFootAngle) {
        builder.addFieldFloat32(14, flatFootAngle, 0.0);
    }
    static addSetupComplete(builder, setupComplete) {
        builder.addFieldInt8(15, +setupComplete, +false);
    }
    static endStayAlignedSettings(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createStayAlignedSettings(builder, enabled, extraYawCorrection, hideYawCorrection, standingEnabled, standingUpperLegAngle, standingLowerLegAngle, standingFootAngle, sittingEnabled, sittingUpperLegAngle, sittingLowerLegAngle, sittingFootAngle, flatEnabled, flatUpperLegAngle, flatLowerLegAngle, flatFootAngle, setupComplete) {
        StayAlignedSettings.startStayAlignedSettings(builder);
        StayAlignedSettings.addEnabled(builder, enabled);
        StayAlignedSettings.addExtraYawCorrection(builder, extraYawCorrection);
        StayAlignedSettings.addHideYawCorrection(builder, hideYawCorrection);
        StayAlignedSettings.addStandingEnabled(builder, standingEnabled);
        StayAlignedSettings.addStandingUpperLegAngle(builder, standingUpperLegAngle);
        StayAlignedSettings.addStandingLowerLegAngle(builder, standingLowerLegAngle);
        StayAlignedSettings.addStandingFootAngle(builder, standingFootAngle);
        StayAlignedSettings.addSittingEnabled(builder, sittingEnabled);
        StayAlignedSettings.addSittingUpperLegAngle(builder, sittingUpperLegAngle);
        StayAlignedSettings.addSittingLowerLegAngle(builder, sittingLowerLegAngle);
        StayAlignedSettings.addSittingFootAngle(builder, sittingFootAngle);
        StayAlignedSettings.addFlatEnabled(builder, flatEnabled);
        StayAlignedSettings.addFlatUpperLegAngle(builder, flatUpperLegAngle);
        StayAlignedSettings.addFlatLowerLegAngle(builder, flatLowerLegAngle);
        StayAlignedSettings.addFlatFootAngle(builder, flatFootAngle);
        StayAlignedSettings.addSetupComplete(builder, setupComplete);
        return StayAlignedSettings.endStayAlignedSettings(builder);
    }
    unpack() {
        return new StayAlignedSettingsT(this.enabled(), this.extraYawCorrection(), this.hideYawCorrection(), this.standingEnabled(), this.standingUpperLegAngle(), this.standingLowerLegAngle(), this.standingFootAngle(), this.sittingEnabled(), this.sittingUpperLegAngle(), this.sittingLowerLegAngle(), this.sittingFootAngle(), this.flatEnabled(), this.flatUpperLegAngle(), this.flatLowerLegAngle(), this.flatFootAngle(), this.setupComplete());
    }
    unpackTo(_o) {
        _o.enabled = this.enabled();
        _o.extraYawCorrection = this.extraYawCorrection();
        _o.hideYawCorrection = this.hideYawCorrection();
        _o.standingEnabled = this.standingEnabled();
        _o.standingUpperLegAngle = this.standingUpperLegAngle();
        _o.standingLowerLegAngle = this.standingLowerLegAngle();
        _o.standingFootAngle = this.standingFootAngle();
        _o.sittingEnabled = this.sittingEnabled();
        _o.sittingUpperLegAngle = this.sittingUpperLegAngle();
        _o.sittingLowerLegAngle = this.sittingLowerLegAngle();
        _o.sittingFootAngle = this.sittingFootAngle();
        _o.flatEnabled = this.flatEnabled();
        _o.flatUpperLegAngle = this.flatUpperLegAngle();
        _o.flatLowerLegAngle = this.flatLowerLegAngle();
        _o.flatFootAngle = this.flatFootAngle();
        _o.setupComplete = this.setupComplete();
    }
}
exports.StayAlignedSettings = StayAlignedSettings;
class StayAlignedSettingsT {
    constructor(enabled = false, extraYawCorrection = false, hideYawCorrection = false, standingEnabled = false, standingUpperLegAngle = 0.0, standingLowerLegAngle = 0.0, standingFootAngle = 0.0, sittingEnabled = false, sittingUpperLegAngle = 0.0, sittingLowerLegAngle = 0.0, sittingFootAngle = 0.0, flatEnabled = false, flatUpperLegAngle = 0.0, flatLowerLegAngle = 0.0, flatFootAngle = 0.0, setupComplete = false) {
        this.enabled = enabled;
        this.extraYawCorrection = extraYawCorrection;
        this.hideYawCorrection = hideYawCorrection;
        this.standingEnabled = standingEnabled;
        this.standingUpperLegAngle = standingUpperLegAngle;
        this.standingLowerLegAngle = standingLowerLegAngle;
        this.standingFootAngle = standingFootAngle;
        this.sittingEnabled = sittingEnabled;
        this.sittingUpperLegAngle = sittingUpperLegAngle;
        this.sittingLowerLegAngle = sittingLowerLegAngle;
        this.sittingFootAngle = sittingFootAngle;
        this.flatEnabled = flatEnabled;
        this.flatUpperLegAngle = flatUpperLegAngle;
        this.flatLowerLegAngle = flatLowerLegAngle;
        this.flatFootAngle = flatFootAngle;
        this.setupComplete = setupComplete;
    }
    pack(builder) {
        return StayAlignedSettings.createStayAlignedSettings(builder, this.enabled, this.extraYawCorrection, this.hideYawCorrection, this.standingEnabled, this.standingUpperLegAngle, this.standingLowerLegAngle, this.standingFootAngle, this.sittingEnabled, this.sittingUpperLegAngle, this.sittingLowerLegAngle, this.sittingFootAngle, this.flatEnabled, this.flatUpperLegAngle, this.flatLowerLegAngle, this.flatFootAngle, this.setupComplete);
    }
}
exports.StayAlignedSettingsT = StayAlignedSettingsT;
